import React from "react";
import Sugar from "sugar";

import { useHistory, useLocation } from "react-router-dom";
import { deleteSearchParam } from "./Helpers";
import Modal from "./modules/Modal";

import icon from "./assets/img/elements/close.svg";
import ReactMarkdown from 'react-markdown';

const archie = require("./assets/data/archie.json");

Sugar.extend();

function GlossaryModal({ active, onDismiss}) {

  return (
    <>
      {active && (
        <Modal active={active} onDismiss={onDismiss}>
          <div className="glossary">
            <div className="scorecard-close">
              <Modal.DismissButton>
                <img src={icon} alt="Close" />
              </Modal.DismissButton>
            </div>

            <h2>What is this project?</h2>

            <ReactMarkdown source={ archie.glossary }/>

          </div>
        </Modal>
      )}
    </>
  );
}

export default GlossaryModal;
